import { useEffect, useMemo, useState } from "react";
import { BackgroundLoaderProps } from "../../Layouts/Signinform/Signin.props";

export const useBackgroundLoader = ({
  imageUrl,
  defaultImage,
}: BackgroundLoaderProps) => {
  const [bgLoaded, setBgLoaded] = useState<boolean>(false);
  const [timerDone, setTimerDone] = useState<boolean>(false);

  useEffect(() => {
    const timer = setTimeout(() => setTimerDone(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (imageUrl) {
      setBgLoaded(false);
      const img = new Image();
      img.src = imageUrl;
      img.onload = () => setBgLoaded(true);
      img.onerror = () => setBgLoaded(true);
    } else {
      setBgLoaded(true);
    }
  }, [imageUrl]);

  const getImage = bgLoaded && timerDone;

  const backgroundStyle = useMemo(() => {
    if (!getImage) return {};

    return {
      backgroundImage: `url(${imageUrl || defaultImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      width: "100%",
      height: "100%",
    };
  }, [getImage, imageUrl, defaultImage]);

  return { getImage, backgroundStyle };
};
